module.exports = __webpack_public_path__ + "img/user-pro-big.0d7d5ea6.png";